import { Column, RowAlignedItems } from '@components/LinearLayout';
import { P, PSmall } from '@components/Typography';

import { animated } from '@react-spring/web';
import styled from 'styled-components';

export const CookieBody = styled(animated.div)`
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: ${({ theme }) => theme.color.white};
  overflow: hidden;
`;

export const ButtonView = styled.div`
  padding: 3rem 2rem;
  display: grid;
  grid-template-columns: 1fr auto;
  overflow-y: auto;
  max-height: 60vh;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
`;

export const PermissionView = styled(Column)`
  padding: 3rem 2rem 7rem 2rem;
  max-height: 60vh;
  width: 100%;
  overflow-y: auto;
  gap: 2rem;
`;
export const GdprRoot = styled.div`
  display: flex;
  position: fixed;
  padding: 0;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`;

export const ButtonsWrapper = styled(Column)`
  gap: 1rem;
  width: 40rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    width: 100%;
  }
`;

export const FooterLink = styled.a`
  color: ${({ theme }) => theme.color.gdprGrey};
  border: 0;
  margin: 0;
  height: fit-content;
  box-sizing: border-box;
  font-size: ${({ theme }) => theme.fontSize.size12};
  &:hover {
    outline: none;
    transition: all 0.2s linear;
    text-decoration: none;
    color: ${({ theme }) => theme.color.gdprGrey2};
    cursor: pointer;
  }
  &:active {
    text-decoration: none;
  }
  &:link {
    text-decoration: none;
  }
  &:visited {
    text-decoration: none;
  }
`;

export const Title = styled(P)`
  font-size: ${({ theme }) => theme.fontSize.size22};
  font-weight: ${({ theme }) => theme.fontWeight.weight400};
  color: ${({ theme }) => theme.color.shadeGrey4};
  line-height: ${({ theme }) => theme.lineHeight.height150};
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    text-align: center;
  }
`;

export const Text = styled(PSmall)`
  font-size: ${({ theme }) => theme.fontSize.size16};
  font-weight: ${({ theme }) => theme.fontWeight.weight400};
  color: ${({ theme }) => theme.color.shadeGrey4};
  line-height: ${({ theme }) => theme.lineHeight.height150};
`;

export const SmallText = styled(PSmall)`
  font-size: ${({ theme }) => theme.fontSize.size14};
  font-weight: ${({ theme }) => theme.fontWeight.weight400};
  color: ${({ theme }) => theme.color.mobilityGrey};
  line-height: ${({ theme }) => theme.lineHeight.height150};
  padding-top: 0.6rem;
`;

export const LeftSideBox = styled(Column)`
  padding-right: 2rem;
  gap: 1rem;
`;

export const CheckboxWrapper = styled(RowAlignedItems)`
  justify-content: space-evenly;
  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin: auto;
    align-items: start;
  }
`;

export const ButtonsContainer = styled(RowAlignedItems)`
  justify-content: space-between;
  gap: 2rem;
`;

export const BackText = styled.div`
  color: ${({ theme }) => theme.color.gdprGrey};
  font-size: ${({ theme }) => theme.fontSize.size12};
  &:hover {
    outline: none;
    transition: all 0.2s linear;
    text-decoration: none;
    color: ${({ theme }) => theme.color.gdprGrey2};
    cursor: pointer;
  }
`;

export const CookieItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.color.white};
  padding: 0.5rem 1rem;
`;

export const CookieItem = styled.div<{ $lastItem?: boolean }>`
  display: grid;
  grid-template-columns: minmax(20rem, 30%) 1fr;
  border-bottom: 1px solid ${({ theme }) => theme.color.shadeGrey2};
  ${({ $lastItem }) => $lastItem && 'border-bottom: none;'}
  @media only screen and (max-width: ${({ theme }) =>
    theme.breakpoint.width768}) {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    justify-content: center;
    align-items: center;
  }
`;

export const ToggleWrapper = styled(RowAlignedItems)`
  gap: 1rem;
  padding-bottom: 0.4rem;
`;
